import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { showModal, hideModal } from '../../actions/modalsActions'

import LoginForm from '../Forms/LoginForm';
import SignupForm from '../Forms/SignupForm';
import ChooseSignUp from './ChooseSignUp';
import ReviewForm from '../Forms/ReviewForm';
import AddExistingRelations from './AddExisting/AddExistingRelations';
import AdminEdit from '../Forms/AdminForms/AdminEdit'
import AddRelatedStory from '../Forms/AdminForms/AddRelatedStory';
import AddRelatedBreach from '../Forms/AdminForms/AddRelatedBreach';
import AddNewItem from '../Forms/AdminForms/AddNewItem';
import ImageShow from '../ImageShow';
import Feedback from './Feedback';
import VedioShow from '../VedioShow';
import MessageModal from '../Feedback/MessageModal';
import ChartDataModal from '../Pages/Dashboard/Charts/ChartDataModal';
import AddDetails from './boards/AddDetails';
import SendToPersonalBoard from './boards/SendToPersonalBoard';
import EditSourceForm from '../Pages/Dashboard/sections/newsSection/Forms/EditSourceForm';
import BoardLabelAddForm from '../Pages/Dashboard/sections/boardsSection/BoardLabelAddForm';
import InvitePeople from '../Pages/Dashboard/sections/boardsSection/Modals/InvitePeople';
import EditMembersRole from '../Pages/Dashboard/sections/boardsSection/Modals/EditMembersRole';
import ConfirmModal from './ConfirmModal/ConfirmModal';

export class ModalTemplate extends Component {

    renderContent() {
        const { modalType } = this.props

        switch (modalType.modalType) {
            case 'LOGIN_MODAL':
                return <LoginForm />
            case 'SIGNUP_CHOOSE_MODAL':
                return <ChooseSignUp />
            case 'SIGNUP_MODAL':
                return <SignupForm />
            case 'REVIEW_MODAL':
                return <ReviewForm {...this.props.modalType.modalProps} onModalHide={() => this.props.hideModal()} />
            case 'ADD_EXISTING_RELATIONS':
                return <AddExistingRelations {...this.props.modalType.modalProps} onModalHide={() => this.props.hideModal()} />
            case 'EDIT_ITEM':
                return <AdminEdit {...this.props.modalType.modalProps} onModalHide={() => this.props.hideModal()} />
            case 'ADD_RELATED_STORY':
                return <AddRelatedStory {...this.props.modalType.modalProps} onModalHide={() => this.props.hideModal()} />
            case 'ADD_RELATED_BREACH':
                return <AddRelatedBreach {...this.props.modalType.modalProps} onModalHide={() => this.props.hideModal()} />
            case 'ADD_NEW_ITEM':
                return <AddNewItem {...this.props.modalType.modalProps} onModalHide={() => this.props.hideModal()} />
            case 'BAM_IMAGE':
                return <ImageShow {...this.props.modalType.modalProps} onModalHide={() => this.props.hideModal()} />
            case 'FEEDBACK':
                return <Feedback {...this.props.modalType.modalProps} onModalHide={() => this.props.hideModal()} />
            case 'VIDEO_PLAY':
                return <VedioShow {...this.props.modalType.modalProps} onModalHide={() => this.props.hideModal()} />
            case 'FEEDBACK_MESSAGE':
                return <MessageModal {...this.props.modalType.modalProps} onModalHide={() => this.props.hideModal()} />
            case 'CHART_DATA':
                return <ChartDataModal {...this.props.modalType.modalProps} onModalHide={() => this.props.hideModal()} />
            case 'ADD_DETAILS':
                return <AddDetails {...this.props.modalType.modalProps} onModalHide={() => this.props.hideModal()} />
            case 'SEND_TO_PERSONAL_BOARD':
                return <SendToPersonalBoard {...this.props.modalType.modalProps} onModalHide={() => this.props.hideModal()} />
            case 'EDIT_SOURCE':
                return <EditSourceForm {...this.props.modalType.modalProps} onModalHide={() => this.props.hideModal()} />
            case 'ADD_BOARD_LABEL':
                return <BoardLabelAddForm {...this.props.modalType.modalProps} onModalHide={() => this.props.hideModal()} />
            case 'INVITE_PEOPLE':
                return <InvitePeople {...this.props.modalType.modalProps} onModalHide={() => this.props.hideModal()} />
            case 'EDIT_MEMBERS_ROLE':
                return <EditMembersRole {...this.props.modalType.modalProps} onModalHide={() => this.props.hideModal()} />
            case 'CONFIRM_MODAL':
                return <ConfirmModal {...this.props.modalType.modalProps} onModalHide={() => this.props.hideModal()} />
            default:
                return null
        }
    }

    renderHeader() {
        const closeButton = this.props.modalType.modalProps.closeButton === undefined ? true : this.props.modalType.modalProps.closeButton;
        const title = this.props.modalType.modalProps.title;

        return (
            <Modal.Header className="p-0" closeButton={closeButton}>
                {title && <Modal.Title id="contained-modal-title-vcenter">
                    {title}
                </Modal.Title>}
            </Modal.Header>
        )
    }

    render() {
        return (
            <Modal
                show={this.props.modalVisible}
                onHide={() => this.props.hideModal()}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="login"
                dialogClassName={this.props.modalType.modalProps.dialogClassName}
                backdrop="static"
                enforceFocus={false}

            >
                {this.renderHeader()}
                <Modal.Body>
                    {this.renderContent()}
                </Modal.Body>
            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return { modalType: state.modalType, modalVisible: state.modalVisible }
}

export default connect(mapStateToProps, { showModal, hideModal })(ModalTemplate)
